import { FC, useEffect, useState } from 'react';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { Options, SelectDropDownProps } from './Select.types';
import { DropdownItem, ValueTemplate } from './Templates';

const SelectDropDown: FC<SelectDropDownProps> = ({
  placeholder,
  options,
  handleChange,
  selectDropDownStyle,
  name,
  setValue,
  errorStyle,
  helpText,
  initialSelectedOptions,
  icon,
  disabled = false,
}) => {
  const [selectedOption, setSelectedOption] = useState<Options | null>(null);

  useEffect(() => {
    if (initialSelectedOptions) {
      setSelectedOption(initialSelectedOptions as Options);
    } else {
      setSelectedOption(null);
    }
  }, [initialSelectedOptions]);

  const onOptionChange = (option: Options) => {
    setSelectedOption(option);
    if (name && setValue) {
      setValue(name, option?._id, {
        shouldValidate: true,
      });
    }
    if (handleChange) handleChange(option);
  };

  return (
    <div className="flex flex-col w-full">
      <div
        className={`${icon ? 'flex items-center text-iconColor bg-[#232323] rounded-[6px] px-3' : ''}`}
      >
        {icon}
        <Dropdown
          disabled={disabled}
          unstyled={true}
          value={selectedOption}
          onChange={(e: DropdownChangeEvent) => onOptionChange(e.value)}
          options={options}
          optionLabel="name"
          placeholder={placeholder}
          style={{ ...selectDropDownStyle }}
          className="cursor-pointer h-[38px] border-none flex justify-between px-4 items-center focus:outline-none focus:ring-0 bg-[#232323] text-white rounded-[6px] min-h-12  w-full min-w-fit"
          itemTemplate={(option) => (
            <DropdownItem
              option={option}
              selectedOption={selectedOption}
              onOptionChange={onOptionChange}
            />
          )}
          valueTemplate={() => (
            <ValueTemplate
              selectedOption={selectedOption}
              placeholder={placeholder}
            />
          )}
          panelClassName="bg-[#232323] mt-[7px] border-none rounded-[6px] pb-3 pt-1 overflow-auto min-w-fit focus:outline-none focus:ring-0 pr-3"
        />
      </div>
      <div className={`text-[12.8px] pt-2 font-raleway ${errorStyle}`}>
        {helpText}
      </div>
    </div>
  );
};

export default SelectDropDown;
